import { type MileageToleranceSetting, mileageToleranceAnswerReadSchema } from "@hakili/contracts";
import { t } from "@hakili/i18n";

/**
 * `P1-CNW-063`: the live answer of `GET` and `POST /api/v1/expertise/mileage-tolerance`, parsed by the provider's own READ twin (A48:
 * no hand-written reader). An answer the schema refuses is « Réponse inattendue du serveur. », never a half-drawn section.
 */
export function parseToleranceAnswer(answer: unknown): MileageToleranceSetting {
  const parsed = mileageToleranceAnswerReadSchema.safeParse(answer);
  if (!parsed.success) throw new Error(t("common.error.reponseInattendue"));
  return parsed.data.setting;
}
